import { h } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';

import { showTrailerModal } from 'utils/trailer';

import ScrollList from 'components/scrollList/scrollList';
import YoutubeIcon from 'components/icons/youtubeIcon';

import s from 'components/scrollList/trailersList.sss';

export default class TrailersList extends ScrollList {
	s = s;

	scrollBy(amount = 1) {
		const scrollerStyle = getComputedStyle(this.$scroller);
		const scrollerWidth = this.$scroller.clientWidth - parseFloat(scrollerStyle.paddingLeft) - parseFloat(scrollerStyle.paddingRight);
		const itemsPerPage = Math.max(1, Math.floor(scrollerWidth / (this.$scroller.children[0]?.clientWidth || 1)));
		return super.scrollBy(amount * itemsPerPage);
	}

	trackNavigationClick(direction) {
		Store.emit(actions.TRAILERS_TAB_DIRECTION_CLICK, { direction });
	}

	trackChannelClick() {
		Store.emit(actions.STUDIO_YOUTUBE_CHANNEL_CLICK, { title: 'Universal on Youtube' });
	}

	onTrailerClick(item) {
		const videoId = item.snippet?.resourceId?.videoId;
		if (!videoId) return;
		showTrailerModal({}, `youtube:${videoId}`);
		Store.emit(actions.TRAILERS_TOUT_CLICK, { title: item.snippet.title });
	}

	renderTitle() {
		return (
			<div class={s.titleWrapper}>
				<h2 class={s.title}>{this.props.title}</h2>
				<a class={s.youtubeLink} href="https://www.youtube.com/@UniversalPictures" target="_blank" onClick={this.trackChannelClick}>
					<YoutubeIcon />
					<span>Universal on YouTube</span>
				</a>
			</div>
		);
	}

	renderItem(item) {
		const onClick = () => this.onTrailerClick(item);
		return (
			<div class={s.item} key={item.id}>
				<div class={s.trailerLink}>
					{/* Ok to not use a proper button here since the title already is one for the same action */}
					<div class={s.thumbnail} onClick={onClick}>
						<img src={item.snippet.thumbnails.high.url} alt="" width="640" height="480" loading="lazy" />
						<YoutubeIcon />
					</div>
					<div class={s.details}>
						{/* Have to use an extra wrapper to let the image control the width - is there a better way ? */}
						<div>
							<button class={s.name} onClick={onClick}>{item.snippet.title.replace('|', '-')}</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

}